/**
 * GraphQL selection for `forPaidPartnershipPage.data.attributes`.
 * Shared by LandingBanner (client) and paid landing page getServerSideProps.
 */
export const PAID_LANDING_PAGE_BANNER_FRAGMENT = `
  banner {
    bannerTitle
    bannerSubtitle
    bannerImageWeb {
      data {
        attributes {
          url
        }
      }
    }
    bannerImageMobile {
      data {
        attributes {
          url
        }
      }
    }
    bannerImageTablet {
      data {
        attributes {
          url
        }
      }
    }
    ctaButtonLabel
    ctaLinkRedirection
    clientCompanyLogo {
      data {
        attributes {
          url
        }
      }
    }
    clientCompanyName
    layout
  }
`;
